<template>
  <div>
    <div
      v-if="
        !lineLayout.includes('Minimal') ||
        $isMinimalProfile ||
        this.$isMinimalProfileBanner
      "
    >
      <label for="">
        {{ textFloat }}
        <span class="text-danger" v-if="isRequired">*</span>
      </label>
    </div>
    <v-row no-gutters class="telephone-country">
      <v-col
        v-if="lineLayout.includes('Minimal') && showCountry"
        :cols="$isMinimalProfile && countryList.length == 1 ? 3 : 4"
        :class="{
          'pr-2':
            !lineLayout.includes('Minimal') ||
            $isMinimalCompact ||
            $isMinimalMinibar ||
            $isMinimalProfile
        }"
      >
        <div
          class="dropdown-flag is-minimal-profile"
          v-if="countryList.length == 1 && !$isMinimalCompact"
        >
          <div class="dropdown-select">
            <img
              v-if="getFlag()"
              :src="getFlag()"
              alt="flag"
              style="width: 20px; height: 14px; margin-right: 8px"
            />
            <span>
              {{ getCode(country) }}
            </span>
          </div>
        </div>
        <InputSelect
          v-else
          :title="
            lineLayout.includes('Minimal') &&
            !this.$isMinimalProfile &&
            !this.$isMinimalProfileBanner
              ? 'Country'
              : ''
          "
          :options="countryList"
          valueField="value"
          textField="name"
          :value="country"
          @change="val => getCode(val)"
          :disabled="disabled || disabledCountry || $isMinimalCompact"
          class="country-select-container"
          :data-test="
            $attrs['data-test']
              ? `${$attrs['data-test']}-country-select`
              : undefined
          "
        >
          <!-- style="max-height: unset !important" -->
          <template v-slot:option-first>
            <b-form-select-option value="" disabled>
              -- Please Select Phone Code --
            </b-form-select-option>
          </template>
        </InputSelect>
      </v-col>
      <div style="flex: 1">
        <InputText
          :textFloat="
            (lineLayout.includes('Minimal') &&
              !$isMinimalProfile &&
              !$isMinimalProfileBanner) ||
            $isCleanLayout
              ? textFloat
              : ''
          "
          type="number"
          :value="value"
          name="telephone"
          :placeholder="placeholder"
          @input="e => $emit('update:value', e.target.value)"
          @onkeypress="isNumber($event)"
          :isValidate="isValidate"
          :v="v"
          inputmode="numeric"
          :oninput="input"
          :disabled="disabled"
          :persistentPlaceholder="$isCleanLayout"
          :data-test="
            $attrs['data-test']
              ? `${$attrs['data-test']}-text-input`
              : undefined
          "
        />
      </div>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    textFloat: { required: false, default: "เบอร์โทรศัพท์", Type: String },
    country: { required: true },
    value: { required: true },
    isRequired: { required: false, type: Boolean },
    placeholder: { required: false, default: "เบอร์โทรศัพท์" },
    textValidate: { required: false, default: "Please Input Value." },
    isValidate: { required: false, type: Boolean },
    v: { required: false, type: Object },
    disabled: { required: false, type: Boolean, default: false },
    showCountry: { required: false, type: Boolean, default: true },
    disabledCountry: { required: false, type: Boolean, default: false }
  },
  data() {
    return {
      countryList: [],
      phoneCode: "+66",
      phoneLength: 10
    };
  },
  created() {
    this.getCountry();
  },
  methods: {
    getCode(val, flag = true) {
      if (this.$isMinimalProfile) {
        const a = this.countryList.find(el => el.value == val);

        if (a)
          if (flag) {
            this.$emit("update:country", val);
            this.$emit("update:code", a.dial_code);
            this.phoneCode = a.dial_code;
            this.phoneLength = a.phone_length;
          }
        return this.phoneCode;
      } else {
        const { dial_code, phone_length } = this.countryList.find(
          el => el.value == val
        );
        if (flag) {
          this.$emit("update:country", val);
          this.$emit("update:code", dial_code);
          this.phoneCode = dial_code;
        }

        this.phoneLength = phone_length;
      }
    },

    async getCountry() {
      const res = await this.$config.telephone_country;

      this.countryList = res
        .map(el => {
          const countryCode = el.code?.toLowerCase();
          return {
            ...el,
            name: `${el.dial_code}`,
            value: el.id,
            dial_code: el.dial_code,
            flag: `https://flagcdn.com/w40/${countryCode}.png`,
            is_active: el.is_active
          };
        })
        .filter(
          el => el.is_active == 1 || this.disabled || this.disabledCountry
        );
      if (this.$isMinimalProfile || this.$config.isMinimalSharp)
        this.countryList = [
          ...this.countryList.filter(el => el.id === 196),
          ...this.countryList.filter(el => el.id !== 196)
        ];
      if (this.$isMinimalProfileBanner)
        this.countryList = [
          ...this.countryList.filter(el => el.id === 99),
          ...this.countryList.filter(el => el.id !== 99)
        ];

      if (
        !this.countryList.find(el => el.value == this.country) &&
        !this.disabled &&
        !this.disabledCountry
      )
        this.getCode(this.countryList[0].value);
      else this.getCode(this.countryList[0].value, false);
    },
    input(e) {
      if (e.target.value.length > this.phoneLength) {
        e.target.value = e.target.value.slice(0, this.phoneLength);
        this.$emit("update:value", e.target.value);
        return e.preventDefault();
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getFlag(value) {
      let flag = this.countryList.find(el => el.value == this.country);
      return flag?.flag;
    }
  }
};
</script>
<style lang="scss">
::v-deep(.country-select-container .v-field__input) {
  outline: 1px solid red !important;
}
.dropdown-flag {
  border: 1px solid rgba(0, 0, 0, 0.23);
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  &.is-minimal-profile {
    max-height: 45px !important;
  }
}
.dropdown-select {
  padding: 0.5rem 1rem;
  display: inline-flex;
  align-items: center;
  width: 100%;
  > svg {
    margin-left: auto;
  }
}
</style>
